import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

const navLinks = [
  { label: "Products", href: "#products" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Partners", href: "#partners" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className={`sticky top-0 z-50 transition-all duration-300 ${scrolled
        ? "bg-[#EDE9E1]/90 backdrop-blur-xl border-b border-[#BEBEBD]/40 shadow-sm"
        : "bg-[#EDE9E1] border-b border-transparent"
        }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center h-20 px-6 md:px-12">
        <a
          href="#hero"
          data-testid="navbar-logo"
          className="hover:opacity-80 transition-opacity"
        >
          <img
            src="/images/Divya_Enterprises.png"
            alt="Divya Enterprises"
            className="h-32 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className="text-sm font-semibold tracking-wide text-[#585857] hover:text-[#040404] transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:+919911414981"
            data-testid="navbar-phone-btn"
            className="flex items-center gap-2 bg-[#A7332B] text-[#EDE9E1] px-5 py-2.5 rounded-md text-sm font-bold tracking-wide hover:bg-[#040404] transition-colors"
          >
            <Phone size={14} />
            Call Now
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#040404]"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation menu"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#EDE9E1] border-t border-[#BEBEBD]/40 px-6 pb-6"
        >
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
              className="block py-3 text-base font-semibold text-[#585857] hover:text-[#040404] transition-colors border-b border-[#BEBEBD]/20"
              onClick={() => setMobileOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:+919911414981"
            data-testid="mobile-phone-btn"
            className="flex items-center justify-center gap-2 mt-4 bg-[#A7332B] text-[#EDE9E1] px-5 py-3 rounded-md text-sm font-bold"
          >
            <Phone size={14} />
            +91 9911414981
          </a>
        </div>
      )}
    </nav>
  );
}
